import { ManageAssetsTabGeneralController } from './manage-assets-tab-general.controller'

function manageAssetsTabGeneral () {
  return {
    restrict: 'E',
    scope: {
      assets: '<',
      form: '=',
      flags: '=',
      getAllTags: '&',
      tagsOptions: '<',
      hasMoreTagsToLoad: '<',
      tagsPagination: '<',
      tagsPricingDisabled: '='
    },
    templateUrl: '/repository/directives/manage-assets-tab-general/manage-assets-tab-general-directive.html?$$REVISION$$',
    controller: ManageAssetsTabGeneralController
  }
}

export { manageAssetsTabGeneral }
